import { render, staticRenderFns } from "./InstructionShow.vue?vue&type=template&id=7585ab22"
import script from "./InstructionShow.vue?vue&type=script&lang=js"
export * from "./InstructionShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports